// extracted by mini-css-extract-plugin
export default {"reValidateCardSection":"Uaa-z","paymentSection":"Vaa-z","disabled":"Waa-z","sectionButtons":"Xaa-z","usingAmazonPayMsg":"Yaa-z"};